// Where Cognito sent a code, in words that finish "Enter the verification code we
// sent ...": "by text message to the number ending in 0142" or "by email to j***@a***".
// Cognito masks the destination itself.
export function phoneTail(destination) {
  const digits = String(destination || '').replace(/\D/g, '');
  return digits.length >= 4 ? digits.slice(-4) : '';
}

export function deliveryPhrase(details) {
  if (details?.deliveryMedium === 'SMS') {
    const tail = phoneTail(details.destination);
    return tail ? `by text message to the number ending in ${tail}` : 'by text message';
  }
  return details?.destination ? `by email to ${details.destination}` : 'to your email';
}
